import { render, staticRenderFns } from "./AuthorInfoIbookUsagePerWeekItem.vue?vue&type=template&id=13b44a91&scoped=true"
import script from "./AuthorInfoIbookUsagePerWeekItem.vue?vue&type=script&lang=ts"
export * from "./AuthorInfoIbookUsagePerWeekItem.vue?vue&type=script&lang=ts"
import style0 from "./AuthorInfoIbookUsagePerWeekItem.vue?vue&type=style&index=0&id=13b44a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b44a91",
  null
  
)

export default component.exports